import React, { Component } from 'react';
import { Row } from 'reactstrap';
import LoaderWrapper from '../../Components-2025/QuestionBank/LoaderWrapper';
import VideoCard from '../../Components-2025/Videos/videoCard';
import ComponentHeader from '../../common/ComponentHeader';
import { SUBSCRIPTION_TYPES } from '../../common/constant';
import { messages } from '../../common/messages';
import { showInformation } from '../../common/toast';
import ModalComponent from '../Common/Modal';
import config from '../config/AppRoutes';
import { nextAwareRoute } from '../../common/cfa2NextRoutes';
import apiServiceProvider from './ApiService';

export default class index extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      videoData: [],
      isLoading: true,
      isPremiumPopupOpen: false,
      isLastVideoViewButtonDisabled: false,
      isUserSubscriptionStatus: false,
    };
  }
  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.retrieveVideos();
  }

  retrieveVideos = async () => {
    const result = await apiServiceProvider['retrieveVideos']();
    if (result.success) {
      const subscriptionDetail =
        result.selectedExamSubscriptionDetails[result.associatedSubscriptionKey];
      this.setState({
        videoTableNameKey: result.associatedVideosTable,
        isLoading: false,
        videoData: result.data,
        isUserSubscriptionStatus:
          subscriptionDetail &&
          (subscriptionDetail.videoStatus ||
            subscriptionDetail.package_val === SUBSCRIPTION_TYPES.EXPENSIVE),
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  redirectToSubscription = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };

  onHandleToggleAlert = () => {
    this.setState({ isPremiumPopupOpen: !this.state.isPremiumPopupOpen });
  };

  // Chapter id for the playlist URL. CFA2 videos belong to their chapter through
  // chapter_id_2025 (chapter_id is the legacy 2022/2023 classification: NULL on admin-created
  // videos, stale on some cloned ones). Other exams' video tables only have chapter_id.
  // Mock/case/pathway videos are opened by their query ids, so they keep chapter_id.
  playlistChapterId = (video) => {
    if (!video) return null;
    if (video.mock_id || video.case_id || video.pathway_id) return video.chapter_id;
    return video.chapter_id_2025 !== undefined && video.chapter_id_2025 !== null
      ? video.chapter_id_2025
      : video.chapter_id;
  };

  redirectToPlaylist = (items) => {
    const { router } = this.context;
    const { id } = items;
    router.push({
      pathname: nextAwareRoute(config.VIDEOS_LIST)
        .replace(':chapterId', this.playlistChapterId(items))
        .replace(':id', id),
      query: {
        ...(items.mock_id && { mockId: items.mock_id }),
        ...(items.case_id && { caseId: items.case_id }),
        ...(items.pathway_id && { pathwayId: items.pathway_id }),
      },      
    });
  };
  redirectToLastViewedVideo = async () => {
    this.setState({ isLastVideoViewButtonDisabled: true });
    const result = await apiServiceProvider['retrieveLastViewedVideo']();
    if (result.success) {
      const { router } = this.context;
      const { data, associatedVideosTable } = result;
      router.push({
        pathname: nextAwareRoute(config.VIDEOS_LIST)
          .replace(
            ':chapterId',
            this.playlistChapterId(data[associatedVideosTable]),
          )
          .replace(':id', data.contentID),
        query: {
          ...(data[associatedVideosTable].mock_id && {
            mockId: data[associatedVideosTable].mock_id,
          }),
          ...(data[associatedVideosTable].case_id && {
            caseId: data[associatedVideosTable].case_id,
          }),
          ...(data[associatedVideosTable].pathway_id && {
            pathwayId: data[associatedVideosTable].pathway_id,
          }),
        },        
      });
    } else {
      this.setState({ isLastVideoViewButtonDisabled: false });
      showInformation(messages.VIDEO_NOT_AVAILABLE);
    }
  };
  render() {
    const { state } = this;
    const {
      isLoading,
      isPremiumPopupOpen,
      isUserSubscriptionStatus,
      isLastVideoViewButtonDisabled,
      videoData,
      videoTableNameKey,
    } = state;
    let caseIndex = 1,
      mockIndex = 1,
      pathwayIndex = 1,
      normalIndex = 1;
    return (
      <div className='animated fadeIn'>
        <div>
          <ComponentHeader title={messages.VIDEOS} className='mb-3'>
            <button
              className='btn btn-primary pointer_class'
              onClick={() => this.redirectToLastViewedVideo()}
              disabled={isLastVideoViewButtonDisabled}
            >
              {isLastVideoViewButtonDisabled && <i className='fa fa-spinner fa-spin mr-1' />}
              {messages.GO_TO_MY_LAST_VIEWED_VIDEO}
            </button>
          </ComponentHeader>
          <LoaderWrapper isLoading={isLoading}>
            <Row className='video_lesson_wrap'>
              {videoData.length > 0 &&
                videoData.map((item) => {
                  let index = item.case_id
                  ? caseIndex++
                  : item.mock_id
                  ? mockIndex++
                  : item.pathway_id
                  ? pathwayIndex++
                  : normalIndex++;                
                  return (
                    <VideoCard
                      index={index++}
                      currentItem={item}
                      chapterIdKey='id'
                      chapterNameKey='chapter_name'
                      videoTableNameKey={videoTableNameKey}
                      isUserSubscribed={isUserSubscriptionStatus}
                      premiumModalToggle={this.onHandleToggleAlert}
                      redirectToPlaylist={this.redirectToPlaylist}
                    />
                  );
                })}
            </Row>
          </LoaderWrapper>
        </div>
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.redirectToSubscription}
          toggleAlert={this.onHandleToggleAlert}
          alert_status={isPremiumPopupOpen}
          MessageContent={messages.CFA1_2025_PREMIUM_POPUP}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Videos/index.jsx